import request from '@/api/request'
//PC工作通-审批列表
export function leaveUserList(data) {
    return request({
        url: '/web/leave/user/list',
        method: 'GET',
        params: data
    })
}


//PC工作通-审批添加
export function leaveUserAdd(data) {
    return request({
        url: '/web/leave/user/add',
        method: 'POST',
        data
    })
}

//PC工作通-审批设置详情
export function leaveInfo(data) {
    return request({
        url: '/web/leave/get/info',
        method: 'GET',
        params: data
    })
}


//PC工作通-收款列表
export function paymentUserList(data) {
    return request({
        url: '/web/payment/user/list',
        method: 'GET',
        params: data
    })
}


//PC工作通-收款详情 接口有问题
export function paymentUserInfo(data) {
    return request({
        url: '/web/payment/user/info',
        method: 'GET',
        params: data
    })
}


///
//PC工作通-收款确认
export function paymentUserAffirm(data) {
    return request({
        url: '/web/payment/user/affirm',
        method: 'POST',
        data
    })
}

